import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Table,
  Form,
  Button,
  Card,
  Typography,
  Divider,
  Modal,
  message,
} from "antd";
import FeatherIcon from "feather-icons-react";
import StepPay from "./step-pay"; // Import StepPay

const { Title } = Typography;

const StepFinal = ({ form, formData, saveShipmentData }) => {
  const [invoiceData, setInvoiceData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    if (formData?.items?.length) {
      const formattedData = formData.items.map((item, index) => ({
        key: index + 1,
        row: index + 1,
        details: (
          <div className="product-info">
            <h4 className="product-info-title">{item.description || "N/A"}</h4>
            <p style={{ fontSize: "12px", color: "#666" }}>
              <strong>Commodity Code:</strong> {item.commodityCode || "N/A"} |{" "}
              <strong>Weight:</strong> {item.weight} kg
            </p>
          </div>
        ),
        unit: `$${item.value ? item.value.toFixed(2) : "0.00"}`,
        quantity: item.quantity || 1,
        total: `$${(item.value ? item.value * item.quantity : 0).toFixed(2)}`,
      }));
      setInvoiceData(formattedData);
    }
  }, [formData]);

  const invoiceTableColumns = [
    { title: "#", dataIndex: "row", key: "row", width: 50, align: "center" },
    { title: "Product Details", dataIndex: "details", key: "details" },
    { title: "Price Per Unit", dataIndex: "unit", key: "unit", align: "right" },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      align: "center",
    },
    { title: "Order Total", dataIndex: "total", key: "total", align: "right" },
  ];

  const showPaymentModal = () => {
    setIsModalVisible(true);
  };

  const handlePaymentSuccess = async () => {
    setIsModalVisible(false);
    const isSaved = await saveShipmentData();
    if (isSaved) {
      message.success("Payment successful! Shipment data has been saved.");
    } else {
      message.error("Failed to save shipment data.");
    }
  };

  return (
    <Form form={form} layout="vertical">
      <Card style={{ padding: "20px" }}>
        <Title level={2} style={{ textAlign: "center", marginBottom: "20px" }}>
          Invoice
        </Title>

        <Table
          dataSource={invoiceData}
          columns={invoiceTableColumns}
          pagination={false}
          bordered
          style={{ marginBottom: "20px" }}
        />

        <Divider />

        <Row justify="center" gutter={[16, 16]} style={{ marginTop: "20px" }}>
          <Col>
            <Button
              size="large"
              type="primary"
              icon={<FeatherIcon icon="credit-card" />}
              onClick={showPaymentModal}
            >
              Payment Now
            </Button>
          </Col>
        </Row>

        {/* Modal for Payment */}
        <Modal
          title="Complete Your Payment"
          open={isModalVisible} // Replaced `visible` with `open` (Ant Design v4 update)
          onCancel={() => setIsModalVisible(false)}
          footer={null}
          width={600}
        >
          <StepPay form={form} formData={formData || {}} />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            <Button type="primary" size="large" onClick={handlePaymentSuccess}>
              Complete Payment
            </Button>
          </div>
        </Modal>
      </Card>
    </Form>
  );
};

StepFinal.propTypes = {
  form: PropTypes.object.isRequired,
  formData: PropTypes.object,
  saveShipmentData: PropTypes.func.isRequired,
};

StepFinal.defaultProps = {
  formData: {}, // Default kosong agar tidak error
};

export default StepFinal;
